import { createFileRoute } from "@tanstack/react-router";
import { VisitPage, visitHeadDa } from "@/pages/VisitPage";

export const Route = createFileRoute("/visit")({
  head: visitHeadDa,
  component: VisitPage,
});
